import moment from 'moment';
import React from 'react'
import ReactModal from 'react-modal'
import { getCaseType } from 'Utils';
import { X } from 'lucide-react';
import PreApproveAttorneysTable from 'Components/Client/Cases/CaseDetails/PreApproveAttorneysTable';
import QcrLoader from 'Components/Icons/QcrLoader';

function PreApproveCaseModal({uploadNew,
    availableProfessionals,
    showAttModal,
    findAttorneys,
    setShowAttModal,
    caseList, caseInfo, setCaseInfo, onClose, onSubmit, approveProfessional, profList}) {
  return (
    <ReactModal
    shouldCloseOnEsc = {true}
    shouldCloseOnOverlayClick = {true}
    onRequestClose={onClose}
    isOpen = {uploadNew}
    style={{
        overlay: {
          zIndex: 30,
          backgroundColor: 'rgba(20,33,61,.4)'
        },
        content: {
            zIndex: 30,
            height: 'auto',
            maxHeight: '85vh',
            overflowY: 'auto',
            width: '520px',
            maxWidth: '92vw',
            top: '50%',
            padding: '28px 28px 24px',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            border: '1px solid rgba(20,33,61,.14)',
            borderRadius: '14px',
            backgroundColor: '#fffdf8',
            boxShadow: '0 12px 32px rgba(20,33,61,.3)',
            transform: 'translate(-50%, -50%)',
        }
      }}
    >
        <div className='flex flex-col w-full font-plexsans'>

            <div className='flex items-start justify-between'>
                <div>
                    <div className='font-spectral text-navy text-[19px] font-semibold'>Find a law firm</div>
                    <div className='text-[12.5px] text-[rgba(20,33,61,.55)] mt-1'>Pre-approve a match so they can view this case before requesting it</div>
                </div>
                <button type="button" onClick={onClose} className='flex-none text-[rgba(20,33,61,.4)] hover:text-navy transition-colors cursor-pointer bg-transparent border-none p-1 -mt-1 -mr-1'>
                    <X size={20}/>
                </button>
            </div>

            <div className='relative mt-5'>
                <select
                    name="case"
                    value={caseInfo?._id}
                    onChange={(e) => {
                        setShowAttModal(false);
                        setCaseInfo((prev) =>
                        {
                            const newItem = caseList?.filter(item => item._id === e.target.value)
                            return {_id: newItem[0]?._id, caseType: newItem[0]?.caseType, caseState: newItem[0]?.caseState};
                        }
                      );
                    }}
                    className="appearance-none block w-full box-border rounded-lg border-[1.5px] border-[rgba(20,33,61,.18)] py-3 pl-3.5 pr-9 text-[13.5px] text-navy bg-ivory focus:outline-none focus:border-tan cursor-pointer font-plexsans"
                >
                      {caseList?.map((item) => <option key={item?._id} value={item?._id}>{getCaseType(item?.caseType)} case against {item?.adversePartyName} posted on {moment(item.created_at).format("MM-DD-YYYY")}</option>)}
                </select>
                <svg className="pointer-events-none absolute right-3.5 top-1/2 -translate-y-1/2" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="rgba(20,33,61,.45)" strokeWidth="2"><path d="M6 9l6 6 6-6"/></svg>
            </div>

            <div className='h-px bg-[rgba(20,33,61,.1)] my-5' />

            <div className='text-[11px] font-semibold tracking-[0.08em] text-[rgba(20,33,61,.4)] uppercase mb-3'>
                Matching profiles &middot; Premium listings only
            </div>

            <div className='w-full flex'>
                {findAttorneys ? (
                    <div className='w-full flex flex-col items-center justify-center py-10 text-[13px] text-[rgba(20,33,61,.5)]'>
                        <QcrLoader variant="draw" size={36} className="mb-3" />
                        Finding matching profiles&hellip;
                    </div>
                ) : showAttModal && availableProfessionals && (
                    <div className='flex w-full flex-col justify-between'>
                        {
                            availableProfessionals?.length === 0 ?
                           <div className='text-center py-8 flex flex-col w-full h-full justify-center items-center text-[13.5px] text-navy'>
                             No law firms available to pre-approve
                             <span className='text-[12px] text-[rgba(20,33,61,.5)] mt-1'>We suggest you wait for law firms to send in their requests.</span>
                           </div>
                          :
                        <PreApproveAttorneysTable
                          onClose={() => setShowAttModal(false)}
                          profList = {availableProfessionals}
                          approveProfessional={approveProfessional}
                          onSubmit={onSubmit}
                          caseDetails={caseInfo}
                        />
                   }
                    </div>
                )}
            </div>
         </div>
    </ReactModal>
  )
}

export default PreApproveCaseModal
